module.exports = __webpack_public_path__ + "assets/ef2e276ed81ab43055183966ec3bfe50.png";